export default __webpack_public_path__ + "6f7a5ce2177f05b9b716359205d6f532.png";